import { Text } from "@overmap-ai/blocks"
import type { IssueType, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { IssueTypeIcon } from "../../../components/Icons/IssueTypeIcon"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type IssueTypeMentionListProps = MentionListRootProps<Stored<IssueType>>

export const IssueTypeMentionList = memo(
	forwardRef<MentionListRef<Stored<IssueType>>, IssueTypeMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<IssueType>> ref={ref} {...props}>
				{items.map((issueType) => (
					<MentionListItem<Stored<IssueType>> item={issueType} key={issueType.uuid}>
						<IssueTypeIcon issueTypeId={issueType.uuid} inline />
						<Text className="truncate">{issueType.name}</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
IssueTypeMentionList.displayName = "IssueTypeMentionList"
